import React from 'react';

import './css/band.css';

class Band extends React.Component {

  render() {
    return <span className="band"/>
  }

}

export default Band;


// WEBPACK FOOTER //
// ./src/Band.js